import React from 'react';
import { Input, Control, ErrorComponent, Link, Checkbox } from "MWComponents";
import "../less";
import css from '../../Express/less/form/form.m.less';
import green_card_order_img from "../img/green_card_order_img.png";
import green_card_mobile_img from "../img/green_card_mobile_img.png";
import yellow_card_order_img from "../img/yellow_card_order_img.png";
import platinum_card_img from "../img/platinum_card_img.png";
import support_card_order_img from "../img/support_card_order_img.png";
import vygoda_card_order_img from "../img/vygoda_card_order_img.png";
import ut_card_order_img from "../img/ut_card_order_img.png";
import atb_card_order_img from "../img/atb_card_order_img.png";
import repair_card_order_img from "../img/repair_card_order_img.png";
import kid_card_order_img from "../img/kid_card_order_img.png";
import bolt_card_order_img from "../img/bolt_card_order_img.png";
import diia_card_order_img from "../img/diia_card_order_img.png";
import cashback_ua_img from "../img/cashback_ua_img_2.png";

export default function template() {
    const model = this.getModel(),
        { contactPhoneNumber } = model.fields,
        { isMobile, card } = this.props,
        imageObject = {
            yellow: {
                desktop: yellow_card_order_img,
                mobile: yellow_card_order_img
            },
            green: {
                desktop: green_card_order_img,
                mobile: green_card_order_img
            },
            platinum: {
                desktop: platinum_card_img,
                mobile: platinum_card_img
            },
            support: {
                desktop: support_card_order_img,
                mobile: support_card_order_img
            },
            ukrainians_together: {
                desktop: ut_card_order_img,
                mobile: ut_card_order_img
            },
            vygoda: {
                desktop: vygoda_card_order_img,
                mobile: vygoda_card_order_img
            },
            atb: {
                desktop: atb_card_order_img,
                mobile: atb_card_order_img
            },
            eVidnovlennia: {
                desktop: repair_card_order_img,
                mobile: repair_card_order_img
            },
            'kid-card': {
              desktop: kid_card_order_img,
              mobile: kid_card_order_img
            },
          bolt: {
            desktop: bolt_card_order_img,
            mobile: bolt_card_order_img
          },
          diia: {
            desktop: diia_card_order_img,
            mobile: diia_card_order_img
          },
          'cashback_ua': {
            desktop: cashback_ua_img,
            mobile: cashback_ua_img
          },
        },
        form = isMobile ?
          (<div className="card-order">
            <div className="img-wrap">
                <img className="order-img" alt="order_green_card"
                     src={imageObject[card] ? imageObject[card].mobile : green_card_mobile_img}></img>
              <div className="shadow"></div>
            </div>
            <div className="body-wrap">
              <div className="title">{this.l10n('GREEN_CARD_DOWNLOAD_TITLE_TEXT')}</div>
              <div className="sub-title">{this.l10n('GREEN_CARD_DOWNLOAD_DESC_TEXT')}</div>
              <div className="download-block">
                <a href={"https://itunes.apple.com/us/app/abank24/id1261267716?ls=1&mt=8"} target="_blank" className="download-block-img apple"></a>
                <a href={"https://play.google.com/store/apps/details?id=ua.com.abank"} target="_blank" className="download-block-img google"></a>
                <a href={"https://appgallery.huawei.com/app/C102212413?sharePrepath=ag&locale=uk_uk"} target="_blank" className="download-block-img app-gallery"></a>
              </div>
              <div className="button-wrapper">
                <Link href="https://a-bank.com.ua/services/abank">
                <button className="button btn-success">{this.l10n('WHAT_IS_A24')}</button>
                </Link>
                <button className="button btn-transparent">{this.l10n('GET_BACK')}</button>
              </div>
            </div>
          </div>) :
          (<React.Fragment>
              <div className="left-side">
                <div className="left-side">
                  <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                  <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                  <div className="card-order">
                    <div className="order-wrapper green-card">
                        <Input
                          {...this.bindProps('phone')}
                          name="contactPhoneNumber"
                          value={contactPhoneNumber.value}
                          onChange={this.handleChange}
                          onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                          label={this.l10n('CARDS_ORDER_LABEL_PHONE')}
                          format={this._phoneFormat}
                          stringify={this._phoneFormat}
                          defaultValue="+38 (0"
                          placeholder="+380 (XX) XXX XX XX"
                          floating={false}
                          className={`w-wide ${contactPhoneNumber.errors.length &&
                          !contactPhoneNumber.firstInput ? 'err-field' : ''}`}
                        />
                        <div className={`error-message ${contactPhoneNumber.errors.length && !contactPhoneNumber.firstInput
                          ? 'active'
                          : ''
                          }`}
                        >
                          <div>{this.l10n(contactPhoneNumber.errors.join('.'))}</div>
                        </div>
                    </div>
                    {card === 'kid-card' ?
                      <div className="control">
                        <Checkbox
                          type="checkbox"
                          {...this.bindProps('checkbox')}
                          label={this.l10n('ACCEPT_AGE')}
                          className={`w-wide ${this.getError('checkbox').length ? 'err-field' : ''}`}
                          onChange={()=>this.handleCheckbox()}
                        />
                      </div>
                      :
                      ''}
                    <div className="button-wrapper">
                      <button className="button button-order"
                              onClick={this.sendForm}
                              disabled={!model.canSubmit}>
                        {this.l10n('GET_LINK')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
                  <img className="order-img" alt="order_green_card"
                       src={imageObject[card] ? imageObject[card].desktop : green_card_order_img}></img>
            </React.Fragment>
        ),
        success = (
            <React.Fragment>
                <div style={{ marginTop: '20px' }}>
                    <Control className={css.result}>
                        <div className={css.resultIcon} />
                        <h2>{this.l10n('EXPRESS_RESULT_GREEN_CARD')}</h2>
                    </Control>
                </div>
            </React.Fragment>
        ),
        error = (
            <Control className="control" style={{ marginTop: '30px' }}>
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </Control>
        ),
        screens = {
            form,
            success,
            error
        };
    this.state.productName = card;

    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className={`form-container card-order-wrapper ${card}`}>
                <div className="close-button" />
                {screens[this.state.activeScreen]}
            </div>
        </div>
    )
}
